import React, { useState, useEffect } from 'react';
import { Col, Input, Panel, Row, InputPicker, SelectPicker, InputNumber } from 'rsuite';
import { ControlCol, ControlRow2, CustomInput, ThreeControlRow } from './costing-page1';
import globalIP from '../../GlobelIP';
import axios from 'axios';

export const PackingSection = React.memo(
  ({
    setTotalCBM,
    setTotalCBMperpc,
    label,
    setFeet40,
    setFeet20,
    productData,
    fieldData,
    showTables,
    setReload,
    setReload2,
    handleFieldDataValue,
    state,
    setPackaging,
    cartoonSize,
    setCartoonSize,
    packaging,
    setTotalMasterPC,
    totalMasterPC,
    setTotalInnerPc,
    totalInnerPc,
    handleReload,
    handleFieldUpdate,
    updatingCalc,
    selectedcurr
  }) => {
    useEffect(() => {
      // setPackaging(productData?.Packaging)
      const updatedPackaging = productData?.Packaging;
      // setProductPackaging(updatedPackaging)

      async function packingData() {
        try {
          const response = await fetch(
            `${globalIP}/api/costings?populate=*&filters[prdcd]=${fieldData.prdcd}`
          );
          const res = await response.json();
          if (res.data.length > 0 && res.data[0].attributes?.CartonSize.length > 0) {
            setFeet40(res.data[0].attributes.Fortyfeet);
            setFeet20(res.data[0].attributes.TwentyFeet);
            setTotalCBMperpc(res.data[0].attributes.CbmPcs);
            setTotalCBM(res.data[0].attributes.CartnCBM);
            let newPack = res?.data[0].attributes?.CartonSize?.map(item => {
              return {
                id: item.id,
                CartonType: item.Type,
                Carton_Thick: item.Height,
                Carton_Length: item.Length,
                Carton_Width: item.Width,
                Carton_Unit: item.Unit,
                Carton_PCS: item.Pcs
              };
            });
            setCartoonSize(newPack);
          } else {
            setCartoonSize(updatedPackaging);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
      packingData();
    }, []);

    const [alreadyupdated, setAlreadyupdated] = useState(false);
    useEffect(() => {
      if (cartoonSize.length >= 1 &&
        cartoonSize[0].Carton_Length != 0 &&
        cartoonSize[0].Carton_Width != 0 &&
        cartoonSize[0].Carton_Thick != 0 && !alreadyupdated) {
        // handleCartonSizeChange(0, 'Carton_PCS', 0)
        setTimeout(() => {
          // console.log('aya ma idhar'  );

          handleCartonSizeChange(0, 'Carton_PCS', cartoonSize[0].Carton_PCS)
          setAlreadyupdated(true)
        }, 2000);
      }
    }, [cartoonSize.length])


    const handleCartonSizeChange = (id, field, value) => {
      setCartoonSize(prevCartoonSize => {
        const updatedCartoonSize = prevCartoonSize.map(item =>
          item.id === id
            ? {
              ...item,
              [field]: field === 'Carton_Unit' ? value : Number(value)
            }
            : item
        );

        let totalcbmlocal = 0;
        let totalcbmlocalperpc = 0;
        let totalMasterPClocal = 0;
        let totalInnerPClocal = 0;
        updatedCartoonSize.forEach(element => {
          const { Carton_Length, Carton_Width, Carton_Thick, Carton_Unit, Carton_PCS, CartonType } =
            element;
          if (Carton_PCS != 0 && CartonType == 'master') {
            if (Carton_Unit === 'cm') {
              totalcbmlocal += (Carton_Length * Carton_Width * Carton_Thick) / 1000000 / Carton_PCS;
              totalcbmlocalperpc += totalcbmlocal * Carton_PCS;
            } else {
              totalcbmlocal += (Carton_Length * Carton_Width * Carton_Thick) / 61023 / Carton_PCS;
              totalcbmlocalperpc += totalcbmlocal * Carton_PCS;
            }
            totalMasterPClocal += Carton_PCS;
          } else if (Carton_PCS != 0 && CartonType == 'inner') {
            totalInnerPClocal += Carton_PCS;
          }
        });
        setTotalCBMperpc(
          isNaN(parseFloat(totalcbmlocal.toFixed(4))) ? 0 : totalcbmlocal.toFixed(4)
        );
        setTotalCBM(
          isNaN(parseFloat(totalcbmlocalperpc.toFixed(4))) ? 0 : totalcbmlocalperpc.toFixed(4)
        );

        setTotalMasterPC(totalMasterPClocal);
        setTotalInnerPc(totalInnerPClocal);
        setPackaging(updatedCartoonSize);
        return updatedCartoonSize;
      });
    };

    // const handleCartonSizeChange = (id, field, value) => {
    //   // console.log('packaging',packaging)
    //   const updatedPackaging = cartoonSize?.filter(item => item?.CartonType === 'master').map(item =>
    //     item.id === id
    //     ? { ...item, [field]: Number(value) }
    //     : item
    //   );

    //   console.log('updatedPackaging',updatedPackaging)
    //   setPackaging(updatedPackaging);
    // };

    // useEffect(() => {
    //   console.log('packaging',packaging)

    // },[packaging])

    const [siii, setSiii] = useState([
      { label: 'CM', value: 'cm' },
      { label: 'Inch', value: 'inch' }
    ]);
    useEffect(() => {
      const profitPer = +fieldData?.profitper || 0;
      const total = +fieldData?.totalinr || 0;
      const profit = (total * profitPer) / 100;
      const gstcost =((+fieldData.totalinr + profit) * +fieldData?.gstper) / 100 || 0;
      const targetCost = profit + total + gstcost;
      handleFieldDataValue('targetCost2', targetCost);
      handleFieldDataValue('gstcost', gstcost);
      if (!updatingCalc.Profitcost) {
        handleFieldDataValue('profitcost', profit);
      }
    }, [fieldData.totalinr, fieldData?.gstper, fieldData?.profitper]); // Recalculate when total INR changes

    return (
      <Panel bordered style={{ marginTop: '15px', padding: 0 }}>
        <Row gutter={20}>
          <Col xs={24} style={{ marginBottom: '10px' }}>
            <strong>Packing Information</strong>
          </Col>
          <Col xs={10}>
            <ControlCol
              label="Qty in Inner"
              control={<CustomInput id="custinputno" value={totalInnerPc} />}
            />
          </Col>
          <Col xs={10}>
            <ControlCol
              label="Qty in Master"
              control={<CustomInput id="custinputno" value={totalMasterPC} />}
            />
          </Col>
          <Col xs={19}>
            {
              cartoonSize?.map((item, index) => {
                // console.log('productData',productData)
                return (
                  <ControlCol
                    key={index}
                    label="Carton Size"
                    control={
                      <div style={{ display: 'flex', gap: '5px' }}>
                        <Input
                          step={null}
                          type="number"
                          size="xs"
                          value={item.Carton_Length ?? 0}
                          placeholder="Length"
                          onChange={value =>
                            handleCartonSizeChange(item.id, 'Carton_Length', value)
                          }
                          style={{
                            height: '24px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            width: '61px'
                          }}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                        />

                        <Input
                          step={null}
                          type="number"
                          size="xs"
                          value={item.Carton_Width ?? 0}
                          placeholder="Width"
                          onChange={value => handleCartonSizeChange(item.id, 'Carton_Width', value)}
                          style={{
                            height: '24px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            width: '61px'
                          }}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                        />
                        <Input
                          step={null}
                          type="number"
                          size="xs"
                          value={item.Carton_Thick ?? 0}
                          placeholder="Thick"
                          onChange={value => handleCartonSizeChange(item.id, 'Carton_Thick', value)}
                          style={{
                            height: '24px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            width: '61px'
                          }}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                              e.preventDefault();
                            }
                          }}
                        />

                        <SelectPicker
                          data={siii}
                          name={`Unit_${item.id}`}
                          value={item.Carton_Unit}
                          size="xs"
                          searchable={false}
                          style={{ width: '100%' }}
                          cleanable={false}
                          placeholder="Unit"
                          onChange={value => handleCartonSizeChange(item.id, 'Carton_Unit', value)}
                        // style={{ height: "24px", padding: "0px", fontSize: "12px", minHeight: "24px", width:'30%' }} // Adjust as needed
                        />
                        <Input
                          step={null}
                          type="number"
                          size="xs"
                          // min={1}
                          value={item.Carton_PCS ? Math.floor(item.Carton_PCS) : 0}
                          placeholder="Pc"
                          onChange={value =>
                            value >= 0 &&
                            handleCartonSizeChange(
                              item.id,
                              'Carton_PCS',
                              Math.floor(parseInt(value, 10))
                            )
                          }
                          onBlur={() =>
                            handleCartonSizeChange(
                              item.id,
                              'Carton_PCS',
                              Math.floor(parseInt(item.Carton_PCS > 0 ? item.Carton_PCS : 1, 10))
                            )
                          }
                          style={{
                            height: '24px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            width: '61px'
                          }}
                          onKeyDown={e => {
                            if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === '.') {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    }
                  />
                );
              })

              // updatedCosting.length > 0 ?
              // (
              //   updatedCosting?.filter(item => item?.CartonType === 'master').map(
              //     (item, index) => {
              //       console.log('productData',productData)
              //       return (
              //         <ControlCol
              //           key={index}
              //           label="Carton Size"
              //           control={
              //             <div style={{ display: "flex", gap: "5px" }}>
              //               <CustomInput
              // id='custinputno'
              //               step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Length}
              //                 placeholder="Length"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Length", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <CustomInput
              // id='custinputno'
              //               step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Width}
              //                 placeholder="Width"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Width", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <CustomInput
              // id='custinputno'
              //               step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Thick}
              //                 placeholder="Thick"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Thick", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <InputPicker
              //                 data={siii}
              //                 name={`Unit_${item.id}`}
              //                 value={item.Carton_Unit}
              //                 cleanable={false}
              //                 placeholder="Unit"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Unit", value)}
              //               />
              //             </div>
              //           }
              //         />
              //       );
              //     }
              //   )
              // ) :
              // (
              //   productData?.Packaging?.filter(item => item?.CartonType === 'master').map(
              //     (item, index) => {
              //       console.log('productData',productData)
              //       return (
              //         <ControlCol
              //           key={index}
              //           label="Carton Size"
              //           control={
              //             <div style={{ display: "flex", gap: "5px" }}>
              //               <CustomInput
              // id='custinputno'
              //                 step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Length}
              //                 placeholder="Length"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Length", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <CustomInput
              // id='custinputno'
              //                 step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Width}
              //                 placeholder="Width"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Width", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <CustomInput
              // id='custinputno'
              //               step={null}
              //                 type="number"
              //                 size="xs"
              //                 value={item.Carton_Thick}
              //                 placeholder="Thick"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Thick", value)}
              //                 // style={{paddingBlock:'0px'}}
              //               />
              //               <InputPicker
              //                 data={siii}
              //                 name={`Unit_${item.id}`}
              //                 value={item.Carton_Unit}
              //                 cleanable={false}
              //                 placeholder="Unit"
              //                 onChange={value => handleCartonSizeChange(item.id, "Carton_Unit", value)}
              //               />
              //             </div>
              //           }
              //         />
              //       );
              //     }
              //   )
              // )
            }
          </Col>
          {/* <Col xs={5}>
            <ControlCol
              label="Pc / Set"
              // control={<CustomInput 
              // id='custinputno' value={productData?.Packaging?.length} />}
              control={<CustomInput 
              id='custinputno' value={String(1)} />}
            />
          </Col> */}
          <Col xs={24}>
            <Row style={{ marginTop: '17px', padding: '0 8px' }}>
              <Col xs={24} style={{ marginBottom: '15px' }}>
                <ControlRow2
                  label="Total INR"
                  control={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      value={(+fieldData?.totalinr).toFixed(2)}
                    />
                  }
                />
              </Col>

              <Col xs={24} style={{ marginBottom: '15px' }}>
                <ThreeControlRow
                  label="Profit"
                  control={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      value={`${updatingCalc?.Profitper
                        ? +fieldData.profitper
                        : (+fieldData.profitper).toFixed(2)
                        }`}
                      onChange={value => {
                        const total = fieldData?.totalinr;
                        const profit = (+total * +value) / 100;
                        handleFieldDataValue('profitper', value);
                        handleFieldDataValue('profitcost', profit.toFixed(2));
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Profitper', true);
                      }}
                      onBlur={() => handleFieldUpdate('Profitper', false)}
                    />
                  }
                  control2={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      value={`${updatingCalc?.Profitcost
                        ? fieldData.profitcost
                        : (fieldData.profitcost / 1).toFixed(2)
                        }`}
                      onChange={value => {
                        handleFieldDataValue('profitcost', value); // Update the profitcost as well if needed
                        handleFieldDataValue(
                          'profitper',
                          ((+value * 100) / +fieldData?.totalinr).toFixed(2)
                        );
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Profitcost', true);
                      }}
                      onBlur={() => handleFieldUpdate('Profitcost', false)}
                    />
                  }
                />
              </Col>
              <Col xs={24} style={{ marginBottom: '15px' }}>
                <ThreeControlRow
                  label="GST %"
                  control={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      name="gstper"
                      value={`${updatingCalc?.GST ? +fieldData.gstper : (+fieldData.gstper).toFixed(2)
                        }`}
                      onChange={value => {
                        handleFieldDataValue('gstper', value);
                        // const result =
                        //   ((+fieldData.totalinr + +fieldData.profitcost) * +value) / 100;
                        // handleFieldDataValue('gstcost', result.toFixed(2));
                        handleReload();
                      }}
                      onFocus={() => {
                        handleFieldUpdate('GST', true);
                      }}
                      onBlur={() => handleFieldUpdate('GST', false)}
                    />
                  }
                  control2={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      name="gstcost"
                      value={(+fieldData.gstcost).toFixed(2) || ''}
                      readOnly
                    />
                  }
                />
              </Col>
              {/* <Col xs={6} style={{ marginBottom: '16px' }}>
                <ControlCol
                  label="Price"
                  control={<Input value={state?.Currencyrate?.currencyname || ''} size="xs" />}
                />
              </Col> */}



              <Col xs={8} style={{ marginBottom: '16px', whiteSpace: 'nowrap' }}>
                <ControlCol
                  label={`Cost in (${selectedcurr?.label || ''})`}
                  control={
                    <CustomInput id="custinputno" step={null} value={fieldData?.targetcostUSD} />
                  }
                />
              </Col>
              <Col xs={8} style={{ marginBottom: '16px' }}>
                <ControlCol
                  label={label[0]?.CurRate || 'Ex-Rate'}
                  control={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      value={String(fieldData?.currencyRate) || ''}
                      onChange={value => {
                        if (
                          showTables.accessories ||
                          showTables.packing ||
                          showTables.material ||
                          showTables.wood ||
                          showTables.process
                        ) {
                          setReload(prev => !prev);
                        } else {
                          setReload2(prev => !prev);
                        }
                        handleFieldDataValue('currencyRate', value);
                      }}
                    />
                  }
                />
              </Col>
              <Col xs={8} style={{ marginBottom: '16px' }}>
                <ControlCol
                  label="Cost in INR"
                  control={
                    <CustomInput
                      id="custinputno"
                      step={null}
                      value={(+fieldData.targetCost2).toFixed(2)}
                      onChange={value => {
                        // if (
                        //   showTables.accessories ||
                        //   showTables.packing ||
                        //   showTables.material ||
                        //   showTables.wood ||
                        //   showTables.process
                        // ) {
                        //   setReload(prev => !prev);
                        // } else {
                        //   setReload2(prev => !prev);
                        // }
                        // handleFieldDataValue('targetCost', value);
                      }}
                    />
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Panel>
    );
  }
);
